import { FC } from 'react';

import { parse, DATE_FORMAT } from '@eneco/common/date';
import { useFormatter, useTranslation } from '@eneco/i18n';
import { InputDatepicker, Stack, Text } from '@eneco/sparky';
import { ClockIcon } from '@eneco/sparky/icons';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import { DeliveryDateFormFieldsB } from '../utils/deliveryDateOptionSchema_B';

interface CustomDateCardBodyProps {
  control: Control<DeliveryDateFormFieldsB>;
  errors: FieldErrors<DeliveryDateFormFieldsB>;
  fromDate: Date;
  toDate: Date;
  onDayClick: () => void;
}

export const CustomDateCardBody: FC<CustomDateCardBodyProps> = ({
  control,
  errors,
  fromDate,
  toDate,
  onDayClick,
}) => {
  const { date } = useFormatter();
  const { t } = useTranslation();

  return (
    <Stack gap="3">
      <Controller
        control={control}
        name="customStartDate"
        render={({ field: { onChange, value, name } }) => (
          <InputDatepicker
            name={name}
            label={t('custom.dateLabel')}
            hint={t('custom.dateHint')}
            error={errors.customStartDate?.message}
            value={value}
            onDaySelect={d => onChange(d && date.short(d as Date))}
            onDayClick={onDayClick}
            fromDate={fromDate}
            toDate={toDate}
            defaultMonth={value ? parse(value, DATE_FORMAT) : undefined}
            isReadOnly
          />
        )}
      />

      <Stack direction="row" gap="2" alignY="center">
        <ClockIcon color="iconElectricityNew" />
        <Text size="BodyS">{t('custom.considerationPeriod')}</Text>
      </Stack>
    </Stack>
  );
};
